import { handleHttpRequest, http, type HttpResponse } from 'interfaces'
import { type OrgTypesOption, type UpdatedOrgResponse, type Country } from 'services'

export interface SloFilterResults {
  data: ExistingSlo[]
  page_number: number
  page_size: number
  total_pages: number
  total_items: number
}

export interface BaseSlo {
  id?: number | null
  days: number | null
  orgType?: OrgTypesOption | null
  updatedBy?: string | null
  lastUpdated?: string | null
  countries?: Country[]
  country?: Country | null

}

export interface NewSlo extends BaseSlo {
  countries: Country[]
}

export interface ExistingSlo extends BaseSlo {
  country: Country | null
}

export async function sloListFilter (params: any): Promise<SloFilterResults> {
  return await http.get('/api/v1/slos/', {
    params: { ...params }
  }).then(value => value.data)
    .catch(reason => { return { data: [], page_number: 0, page_size: 0, total_items: 0, total_pages: 0 } })
}

export async function getSlo (sloId: number): Promise<ExistingSlo> {
  return await http.get(`/api/v1/slos/${sloId}/`).then(value => value.data)
}

export async function updateSlo (payload: ExistingSlo): Promise<HttpResponse<void>> {
  return await handleHttpRequest(http.patch(`/api/v1/slos/${payload.id ?? ''}/`, payload))
}

export async function createSlo (payload: NewSlo): Promise<HttpResponse<UpdatedOrgResponse>> {
  return await handleHttpRequest(http.post('/api/v1/slos/', { days: payload.days, orgTypeId: payload.orgType?.id, countriesIds: payload.countries.map(value => value.id) }))
}

export async function deleteSlo (sloId: number): Promise<boolean> {
  const urlPath = `/api/v1/slos/${sloId}/`
  return await http.delete(urlPath, { withCredentials: true })
    .then(() => { return true })
    .catch(() => { return false })
}
